// ---------- Helpers ----------
function formatDate(date) {
  var options = { weekday: 'long', day: 'numeric', month: 'long' };
  return date.toLocaleDateString('nl-NL', options).replace(/\s/g, '&nbsp;');
}

var deliveryDayNames = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

// In-stock leverdag (cut-off 13:00)
function calculateInStockDelivery() {
  var now = new Date();
  var d = now.getDay(); // 0=zo, 1=ma, ...
  var h = now.getHours();
  var add = 0;

  if (d >= 1 && d <= 4) {         // ma-do
    add = h < 13 ? 1 : 2;
  } else if (d === 5) {           // vr
    add = h < 13 ? 1 : 4;
  } else if (d === 6) {           // za
    add = 3;
  } else if (d === 0) {           // zo
    add = 2;
  }

  var delivery = new Date();
  delivery.setDate(now.getDate() + add);
  return formatDate(delivery);
}

// OOS leverdag (cut-off 13:00) volgens opgegeven schema
function calculateOutOfStockDelivery() {
  var now = new Date();
  var d = now.getDay();   // 0=zo, 1=ma, ..., 6=za
  var h = now.getHours(); // cut-off 13:00

  // Mapping: doel-weekdag per huidige dag (0=zo...6=za)
  // vóór 13:00
  var mapBefore13 = {
    1: 3, // Ma -> Wo
    2: 5, // Di -> Vr
    3: 5, // Wo -> Vr
    4: 1, // Do -> Ma
    5: 1, // Vr -> Ma
    6: 3, // Za -> Wo
    0: 3  // Zo -> Wo
  };

  // na 13:00
  var mapAfter13 = {
    1: 5, // Ma -> Vr
    2: 5, // Di -> Vr
    3: 1, // Wo -> Ma
    4: 1, // Do -> Ma
    5: 3, // Vr -> Wo
    6: 3, // Za -> Wo
    0: 3  // Zo -> Wo
  };

  // Kies de juiste mapping op basis van cut-off
  var targetDow = (h < 13 ? mapBefore13 : mapAfter13)[d];

  // Bereken volgende datum van die weekdag
  var delivery = new Date(now);
  var diff = (targetDow - d + 7) % 7; // 0..6
  if (diff === 0) diff = 7;           // zekerheidshalve: nooit "vandaag"
  delivery.setDate(now.getDate() + diff);

  return formatDate(delivery);
}

// Tijd tot opgegeven uur (hele uur, lokale tijd)
function timeUntilHour(hour) {
  var now = new Date();
  var cutoff = new Date();
  cutoff.setHours(hour, 0, 0, 0);
  if (now > cutoff) cutoff.setDate(cutoff.getDate() + 1);

  var diff = cutoff - now;
  var h = Math.floor((diff / (1000 * 60 * 60)) % 24);
  var m = Math.floor((diff / (1000 * 60)) % 60);
  var s = Math.floor((diff / 1000) % 60);
  return { h: h, m: m, s: s };
}

// ---------- Leverbelofte winkelwagen ----------
// Vanaf dit bedrag (in centen) geldt de snelle belofte. cart.total_price is ook in centen,
// dus we vergelijken direct met het bedrag zoals het in de winkelwagen staat.
var EXPRESS_DREMPEL_CENTEN = 60000; // € 600,00

// Er wordt niet op zondag bezorgd. Zonder deze correctie belandt een bestelling op
// vrijdag na 23:30 (standaardregel: +2 dagen) op zondag.
function nooitZondag(date) {
  if (date.getDay() === 0) date.setDate(date.getDate() + 1);
  return date;
}

// Onder de drempel: zelfde belofte als de andere webshops.
// - ma t/m vr: cut-off 23:30
// - zaterdag : cut-off 23:59 (altijd verstreken, dus schuift altijd een dag door)
// - zondag   : cut-off 21:00
function deliveryInfoStandaard() {
  var now = new Date();
  var day = now.getDay();
  var totalMinutes = now.getHours() * 60 + now.getMinutes();
  var cutoffReached;
  var cutoffLabel;

  if (day === 6) {                 // zaterdag
    cutoffReached = true;
    cutoffLabel = '23:59';
  } else if (day === 0) {          // zondag
    cutoffReached = totalMinutes >= (21 * 60);
    cutoffLabel = '21:00';
  } else {                         // maandag t/m vrijdag
    cutoffReached = totalMinutes >= (23 * 60 + 30);
    cutoffLabel = '23:30';
  }

  var deliveryDate = new Date(now);
  deliveryDate.setDate(now.getDate() + (cutoffReached ? 2 : 1));

  return { date: nooitZondag(deliveryDate), cutoffLabel: cutoffLabel };
}

// Vanaf de drempel: op werkdagen vóór 17:00 besteld is de volgende dag in huis.
// Na de cut-off gaat de bestelling de eerstvolgende werkdag weg en is hij de dag daarna binnen.
// Dit is dezelfde dagmapping als calculateInStockDelivery hierboven, alleen met 17:00 i.p.v. 13:00.
function deliveryInfoExpress() {
  var now = new Date();
  var d = now.getDay();
  var h = now.getHours();
  var add;

  if (d >= 1 && d <= 4) {          // ma-do: morgen, of overmorgen na de cut-off
    add = h < 17 ? 1 : 2;
  } else if (d === 5) {            // vr: zaterdag, of dinsdag na de cut-off
    add = h < 17 ? 1 : 4;
  } else if (d === 6) {            // za -> di
    add = 3;
  } else {                         // zo -> di
    add = 2;
  }

  var deliveryDate = new Date(now);
  deliveryDate.setDate(now.getDate() + add);

  return { date: nooitZondag(deliveryDate), cutoffLabel: '17:00' };
}

// Winkelwagenbedrag in centen. Staat als data-attribuut op #cart-delivery en wordt
// door Shopify ververst zodra de cart-drawer opnieuw rendert.
function getCartTotaalCenten(wrap) {
  if (!wrap) return 0;
  var waarde = parseInt(wrap.getAttribute('data-cart-total'), 10);
  return isNaN(waarde) ? 0 : waarde;
}

function getDeliveryInfo(totaalCenten) {
  return totaalCenten >= EXPRESS_DREMPEL_CENTEN ? deliveryInfoExpress() : deliveryInfoStandaard();
}

function buildDeliveryMessage(info) {
  return 'Voor ' + info.cutoffLabel + ' besteld, ' + deliveryDayNames[info.date.getDay()] + ' in huis';
}

// Volledige datum voor in de bestelling/bevestigingsmail, bijv. "woensdag 23 september 2026".
function formatExpectedDeliveryDate(date) {
  return date.toLocaleDateString('nl-NL', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}

// ---------- Verwachte bezorgdatum opslaan als cart attribute ----------
// Het hidden input dekt alleen de checkout-knop in de cart-drawer. Daarnaast schrijven we naar
// /cart/update.js, zodat de datum aan de cart hangt en meekomt via welke route er ook wordt afgerekend.
var LAST_SAVED_EXPECTED_DELIVERY = null;
var SAVE_EXPECTED_DELIVERY_TIMER = null;

function saveExpectedDelivery(info) {
  // Het hidden input bestaat alleen als de cart gevuld is; bij een lege cart slaan we niets op.
  var input = document.getElementById('attr-expected-delivery');
  if (!input) return;

  var value = formatExpectedDeliveryDate(info.date);
  input.value = value;

  // Alleen versturen als de datum echt wijzigt: deze functie draait elke seconde.
  if (value === LAST_SAVED_EXPECTED_DELIVERY) return;
  LAST_SAVED_EXPECTED_DELIVERY = value;

  if (SAVE_EXPECTED_DELIVERY_TIMER) clearTimeout(SAVE_EXPECTED_DELIVERY_TIMER);
  SAVE_EXPECTED_DELIVERY_TIMER = setTimeout(function () {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { expected_delivery: value } })
    }).catch(function () {
      // Stil falen: een mislukte call mag de cart niet blokkeren. Bij de volgende
      // wijziging wordt het opnieuw geprobeerd.
      LAST_SAVED_EXPECTED_DELIVERY = null;
    });
  }, 250);
}

// ---------- Productpagina / PDP ----------
// countdown bij varianten (#countdown)
function updateCountdown() {
  // Alleen zichtbare variantregels (theme zet hidden attribuut)
  var nodes = document.querySelectorAll('[data-variant-id]:not([hidden]) #countdown');
  if (!nodes.length) return;

  // Eén keer per tick berekenen – alles nu met cut-off 13:00
  var t13 = timeUntilHour(13);
  var txt13 = t13.h + ' uur ' + t13.m + ' minuten ' + t13.s + ' seconden';

  nodes.forEach(function (el) {
    el.innerHTML = txt13;
  });
}

// leverdatum bij varianten (#delivery-day-instock / #delivery-day-oos)
function updateDelivery() {
  // In-stock datums alleen op zichtbare varianten
  var instockEls = document.querySelectorAll('[data-variant-id]:not([hidden]) #delivery-day-instock');
  if (instockEls.length) {
    var dateIn = calculateInStockDelivery();
    instockEls.forEach(function (el) { el.innerHTML = dateIn; });
  }

  // OOS datums alleen op zichtbare varianten
  var oosEls = document.querySelectorAll('[data-variant-id]:not([hidden]) #delivery-day-oos');
  if (oosEls.length) {
    var dateOOS = calculateOutOfStockDelivery();
    oosEls.forEach(function (el) { el.innerHTML = dateOOS; });
  }
}

// ---------- Cart drawer samenvatting (#cart-delivery) ----------
function updateCartDeliverySummary() {
  var wrap = document.getElementById('cart-delivery');
  if (!wrap) return;

  var info = getDeliveryInfo(getCartTotaalCenten(wrap));

  var messageEl = wrap.querySelector('#delivery-message');
  if (messageEl) {
    var nieuw = buildDeliveryMessage(info);
    // Alleen schrijven bij een echte wijziging, zodat we de DOM niet elke seconde aanraken.
    if (messageEl.innerHTML !== nieuw) messageEl.innerHTML = nieuw;
  }

  saveExpectedDelivery(info);
}

// ---------- Cart: levertijd per line item (.inventory-block) ----------
function updateCartItemsDelivery() {
  var blocks = document.querySelectorAll('.inventory-block[data-cutoff]');
  if (!blocks.length) return;

  blocks.forEach(function (block) {
    // standaard cut-off nu 13:00
    var cutoff = parseInt(block.getAttribute('data-cutoff'), 10) || 13;

    var countdownEl = block.querySelector('.item-countdown');
    var deliveryEl = block.querySelector('.item-delivery-day');

    // Als er geen elementen zijn voor dit block, niets doen
    if (!countdownEl && !deliveryEl) return;

    if (countdownEl) {
      var t = timeUntilHour(cutoff);
      countdownEl.innerHTML =
        t.h + ' uur ' + t.m + ' minuten ' + t.s + ' seconden';
    }

    if (deliveryEl) {
      deliveryEl.innerHTML = (cutoff === 13)
        ? calculateOutOfStockDelivery()
        : calculateInStockDelivery();
    }
  });
}

// ---------- Variant-wissel: direct updaten ----------
function wireVariantListeners() {
  var fire = function () {
    // direct en licht
    updateDelivery();
    updateCountdown();
  };

  // Populaire custom events in Shopify themes
  document.addEventListener('variant:change', fire, true);
  document.addEventListener('variant:changed', fire, true);
  document.addEventListener('product:variant:change', fire, true);
  document.addEventListener('product:variant-changed', fire, true);

  // Standaard <select name="id"> en radio-varianten
  document
    .querySelectorAll('select[name="id"], input[name="id"][type="radio"]')
    .forEach(function (el) {
      el.addEventListener('change', fire, { passive: true });
    });
}

// ---------- Init & interval ----------
document.addEventListener('DOMContentLoaded', function () {
  // Eerste invulling
  updateDelivery();
  updateCountdown();
  updateCartDeliverySummary();
  updateCartItemsDelivery();

  // Countdown + cart-samenvatting + item-levertijden elke seconde
  var paused = false;
  document.addEventListener('visibilitychange', function () {
    paused = document.hidden;
  });

  setInterval(function () {
    if (paused) return;
    updateCountdown();
    updateCartDeliverySummary();
    updateCartItemsDelivery();
  }, 1000);

  // Back-up: datumteksten op PDP elke 60 sec
  setInterval(function () {
    if (paused) return;
    updateDelivery();
  }, 60000);

  // Directe updates bij variant-wissel
  wireVariantListeners();
});

document.addEventListener('shopify:section:load', updateCartDeliverySummary);
